const baseUrl = process.env.BASE_URL || ''

export const appBasePath =
  baseUrl.startsWith('/') && baseUrl !== '/'
    ? baseUrl.replace(/\/+$/, '')
    : ''

export function appUrl(path: string) {
  if (!appBasePath || !path.startsWith('/')) {
    return path
  }
  return `${appBasePath}${path}`
}
